import { render, staticRenderFns } from "./AttendantDepartmentForm.vue?vue&type=template&id=b071533a&scoped=true&"
import script from "./AttendantDepartmentForm.vue?vue&type=script&lang=js&"
export * from "./AttendantDepartmentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b071533a",
  null
  
)

export default component.exports